import { identity, unwrap } from "../api";
import type { IdentityComponents } from "@steelyard/api-client";

/**
 * Site-wide messages (`../Steelyard` contracts/global-messages.md, `GlobalMessageController.cs`).
 * Every route here is `config.administer`. The anonymous `GET /global-messages/active` is the
 * customer surfaces' call, not the back office's.
 */
export type GlobalMessage = IdentityComponents["schemas"]["GlobalMessageView"];
export type GlobalMessageInput = { title: string; body: string; dismissible: boolean; active: boolean };

/** Newest first. */
export async function listGlobalMessages() {
  return unwrap(identity().GET("/api/identity/global-messages"));
}

export async function createGlobalMessage(input: GlobalMessageInput) {
  return unwrap(identity().POST("/api/identity/global-messages", { body: input }));
}

/** Every field is sent. */
export async function updateGlobalMessage(id: string, input: GlobalMessageInput) {
  return unwrap(identity().PUT("/api/identity/global-messages/{id}", { params: { path: { id } }, body: input }));
}

/** The edit page's URL: `/global-messages/MSG-000012`, no GUID (the admin's record-URL rule). */
export const messagePath = (m: Pick<GlobalMessage, "messageNumber">) => `/global-messages/${m.messageNumber}`;
